<template>
  <div class="index">
      <nav class="content">
          <div class="pcheaderBackground" style="display:none">
              <div class="headerContent">
                <img src="../../assets/headerLogo.png"/>
                <ul>
                  <li @click="goHome">Home</li>
                  <li @click="goAboutUs">About us</li>
                  <li @click="goAdvantage">Advantage</li>
                  <li @click="goProvide">Provide</li>
                  <li @click="goContactUs">Contact us</li>
                </ul>
              </div>
          </div>
          <div class="header">
              <img src="../../assets/headerLogo.png"/>
              <ul>
                  <li @click="goHome">Home</li>
                  <li @click="goAboutUs">About us</li>
                  <li @click="goAdvantage">Advantage</li>
                  <li @click="goProvide">Provide</li>
                  <li @click="goContactUs">Contact us</li>
              </ul>
          </div>
          <div class="headerTitle mt_60">
              Make Your Payment Process
          </div>
          <div class="headerTitle">
            Seamless Real-Time and Transparent
          </div>
          <div class="banner">
            <img src="../../assets/banner.png"/>

          </div>
          <div class="about">
              <div class="aboutleft">
                  <p>About PandaPay</p>
                  <div style="margin-bottom:20px">
                      PandaPay is a one-stop solution to optimize your payments to maximize your revenue. Payment success rate and cost vary widely by service, country and many more. PandaPay will allow you intelligently route the transaction to the right mix of payments and related services.
                  </div>
                  <div style="margin-bottom:20px">
                       PandaPay delivers financial services across the globe from India, Indonesia, Vietnam, the Philippines, to Chile, and is expanding to other emerging markets. Our supporting team includes top-caliber talents from Alibaba, Quant Group, Google, and CapitalOne, with remarkable dexterity in financial technology landscape and strategic resources in South East Asia.
                  </div>
                  <div style="margin-bottom:20px">
                       PandaPay is a subsidiary of PandaCredit with various investments from companies such as Alibaba, Quant Group, Fosun Investment, and 500 Startups.
                  </div>
              </div>
              <div>
                <img src="../../assets/about.png"/>
              </div>
          </div>
          <div class="advantage">
              <p>Why Choose Us？</p>
              <div class="advantageList">
                  <div>
                      <img src="../../assets/advantage1.png"/>
                      <p class="advantageTitle">Comprehensive</p>
                      <p class="advantageBody">We cover 100% of the population </p>
                  </div>
                  <div>
                      <img src="../../assets/advantage2.png"/>
                      <p class="advantageTitle">Resources</p>
                      <p class="advantageBody">We provide online and offline payment channel</p>
                  </div>
                  <div>
                      <img src="../../assets/advantage3.png"/>
                      <p class="advantageTitle">Payment</p>
                      <p class="advantageBody">Payments all across Chile</p>
                  </div>
              </div>
              <div class="advantageList">
                  <div>
                      <img src="../../assets/advantage4.png"/>
                      <p class="advantageTitle">Service</p>
                      <p class="advantageBody">Helpful customer services </p>
                  </div>
                  <div>
                      <img src="../../assets/advantage5.png"/>
                      <p class="advantageTitle">Security</p>
                      <p class="advantageBody">Your data is safe with us</p>
                  </div>
                  <div>
                      <img src="../../assets/advantage6.png"/>
                      <p class="advantageTitle">Information</p>
                      <p class="advantageBody">Real-time notifications and information</p>
                  </div>
              </div>
          </div>
          <div class="provide">
            <p class="provideTitle">What We Provide</p>
            <div class="companyTitle">Credit & Debit Cards</div>
            <div class="companyBody">Charge through your website or mobile application with our advanced solutions. Accept credit and debit cards securely</div>
            <div class="provideBanner">
                <div class="mover-1"></div>
            </div>
            <div class="companyTitle">Interbank Transfer </div>
            <div class="companyBody">Allow your customers to make referenced payments from their bank and identify them in real time, without requesting proof of payment</div>
            <div class="provideBanner">
                <div class="mover-1 bannerImg1"></div>
            </div>
            <div class="companyTitle">Offline cash payment services</div>
            <div class="companyBody">In Chile, 57% of Chileans do not have a bank account. So, paying cash for online purchases is a growing trend every day. In fact, more than 90% of transactions are made in cash</div>
            <div class="provideBanner">
                <div class="mover-1 bannerImg2"></div>
            </div>
          </div>
          <div class="contactUs">
                <p class="contactTitle">Contact Us</p>
                <Form ref="form" :model="form" label-position="top" :rules="ruleInline" style="margin-top:100px">
                    <FormItem prop="firstName" label="First Name*" style="display:inline-block">
                        <Input v-model="form.firstName" placeholder="Please enter your first name" style="width:475px;margin-right:46px"></Input>
                    </FormItem>
                    <FormItem  prop="lastName"label="Last Name*" style="display:inline-block">
                        <Input v-model="form.lastName" placeholder="Please enter your last name" style="width:475px;"></Input>
                    </FormItem>
                    <FormItem prop="email" label="Email*" style="display:inline-block;margin-top:57px">
                        <Input v-model="form.email" placeholder="Please enter your Email" style="width:475px;margin-right:46px"></Input>
                    </FormItem>
                    <FormItem prop="phone" label="Phone*" style="display:inline-block;margin-top:57px">
                        <Input v-model="form.phone" placeholder="Please enter your phone" style="width:475px;"></Input>
                    </FormItem>
                    <FormItem prop="message" label="Message*" style="margin-top:57px">
                        <Input type="textarea" placeholder="Please enter your message" v-model="form.message"></Input>
                    </FormItem>
                    <FormItem label="" style="margin-top:57px;text-align:center;margin-bottom:100px;">
                        <Button type="primary" @click="submit('form')">Send</Button>
                    </FormItem>
                </Form>
          </div>
      </nav>
        <nav class="footer">
            <div class="footerContent">
                <div class="footerHeader">
                    <img class="logo" src="../../assets/headerLogo.png"/>
                    <ul>
                        <li @click="goHome">Home</li>
                        <li @click="goAboutUs">About us</li>
                        <li @click="goAdvantage">Advantage</li>
                        <li @click="goProvide">Provide</li>
                        <li @click="goContactUs">Contact us</li>
                    </ul>
                </div>
                <p>
                    <img class="footer1" src="../../assets/footer1.png"/>
                    <img class="footer1" style="margin-top:20px" src="../../assets/footer2.png"/>
                    <img class="footer2" src="../../assets/footer3.png"/>
                    <img class="footer3" src="../../assets/footer4.png"/>
                    <img class="footer4" src="../../assets/footer5.png"/>
                </p>
                <div class="contactUs">
                    <div>Email: serviceteam@pandapay.mx</div>
                    <div>Business hours : 9.00 a.m to 6.00 p.m</div>
                </div>
                <div class="standBy">Copyright © {{year}} Pandapay. All rights reserved.</div>
            </div>
        </nav>
  </div>
</template>

<script>
import apiUrl from '../../services/api/user.service'
export default {
  name: '',
  data () {
    return {
        form:{
            firstName:'',
            lastName:'',
            email:'',
            phone:'',
            message:'',
        },
        year:new Date().getFullYear(),
        ruleInline: {
            firstName: [{
                required: true,
                message: 'Please fill in the first name',
                trigger: 'blur'
            }],
            lastName: [{
                required: true,
                message: 'Please fill in the last name',
                trigger: 'blur'
            }],
            phone: [{
                required: true,
                message: 'Please fill in the phone',
                trigger: 'blur'
            }],
            message: [{
                required: true,
                message: 'Please fill in the message',
                trigger: 'blur'
            }],
            email: [{
                required: true,
                message: 'Please fill in the email',
                trigger: 'blur'
            },{
                type: 'email',
                message: 'Email format is error',
                trigger: 'blur'
            }]
        },
    }
  },
  methods:{
      goHome(){
          window.scrollTo(0, 0)
      },
      goAboutUs(){
          window.scrollTo(0, 950)
      },
      goAdvantage(){
          window.scrollTo(0, 1700)
      },
      goProvide(){
          window.scrollTo(0, 2500)
      },
      goContactUs(){
          window.scrollTo(0, 4050)
      },
      submit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    apiUrl.customer(this.form).then(res => {
                        this.$Notice.success({title: 'Success'})
                        this.form.firstName = ''
                        this.form.lastName = ''
                        this.form.email = ''
                        this.form.message = ''
                        this.form.phone = ''
                    })
                } 
            })

      }
  },
  created() {
    $(window).scroll(function() {
      let topp = $(document).scrollTop();
      if (topp < 100) {
        // 恢复正常流并且瞬间隐藏
        $(".pcheaderBackground").css({
          opacity: 0,
          "pointer-events": "none"
        });
      } else {
        // 先让盒子固定定位在顶部然后下拉
        $(".pcheaderBackground")
          .css({
            opacity: 1,
            position: "fixed",
            top: 0,
            left: 0,
            zIndex:1000,
            "pointer-events": ""
          })
          .slideDown();
      }
    });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.index{
    position: relative;
    background: #1C2244;
    width: 100%;
    .mt_60{
        margin-top: 60px;
    }
    .content{
        width: 1000px;
        margin: 0 auto;
        color: #FFFFFF;
        .header{
            position: relative;
            display: flex;
            img{
                width: 210px;
                height: 42px;
                margin-top: 18.5px;
            }
            ul{
                position: absolute;
                right: 0;
                margin-top: 28.5px;
                list-style: none;
                li{
                    color: #9797B2;
                    cursor: pointer;
                    display: inline-block;
                    margin-left: 40px;
                    font-size: 16px;
                    font-weight: 500;
                }
                li:hover{
                    color: #FFFFFF;
                }
            }
        }
        .headerTitle{
            font-size: 47px;
             
            font-weight: 600;
            color: #FFFFFF;
            line-height: 64px;
            text-align: center;
        }
        .banner{
            width: 100%;
            margin-top: 32.5px;
            img{
                width:100%
            }
        }
        .about{
            display: flex;
            margin-top: 100px;
            color: #A0A2B1;
            .aboutleft{
                width: 48%;
                margin-right: 50px;
                line-height: 36px;
                font-size: 16px;
                 
                color: #A0A2B1;
                p{
                    font-size: 34px;
                     
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 47px;
                    margin-bottom: 28px;
                }
            }
            img{
                width:415px;
                height:376px;
                margin-top: 200px;
            }
        }
        .advantage{
            margin-top: 150px;
            p{
                font-size: 34px;
                 
                font-weight: 600;
                color: #FFFFFF;
                margin: 0;
                text-align: center;
            }
            .advantageList{
                display: flex;
                justify-content: space-between;
                text-align: center;
                margin-top: 100px;
                img{
                    width:77.5px;
                    height: 77.5px;
                }
                .advantageTitle{
                    font-size: 18px;
                     
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 26px;
                    margin-top: 20px;
                }
                .advantageBody{
                    font-size: 14px;
                     
                    font-weight: 400;
                    color: #A0A2B1;
                    line-height: 21px;
                    width:240px;
                    margin-top: 10px;
                }
            }
        }
        .provide{
            margin-top: 170px;
            padding-bottom: 100px;
            .provideTitle{
                font-size: 34px;
                 
                font-weight: 600;
                color: #FFFFFF;
                line-height: 47px;
                margin: 0;
                text-align: center;
            }
            .companyTitle{
                font-size: 20px;
                 
                font-weight: 500;
                color: #FFFFFF;
                line-height: 27px;
                letter-spacing: 1px;
                text-align: center;
                margin-top: 100px;
            }
            .companyBody{
                font-size: 14px;
                 
                font-weight: 400;
                color: #83818B;
                line-height: 25px;
                text-align: center;
                width: 700px;
                margin: 0 auto;
                margin-top: 11px;
            }
            .provideBanner{
                height: 180px;
                max-width: 1000px;
                margin: 0 auto;
                position: relative;
                overflow: hidden;
                transform: translate3d(0, 0, 0);
                margin-top: 68px;
                .mover-1 {
                    animation: moveSlideshow 60s linear infinite;
                    height: 180px;
                    width: 2526px;
                    background: url('../../assets/provideBanner1.png');
                    background-size:1000px 180px ;
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    transform: translate3d(0, 0, 0);
                }
                .bannerImg1{
                    background: url('../../assets/provideBanner2.png') !important;
                    background-size:2700px 180px  !important;
                }
                .bannerImg2{
                    background: url('../../assets/provideBanner3.png') !important;
                    background-size:2000px 180px  !important;
                }
            }
        }
        .contactUs{
            margin-top: 100px;
            .contactTitle{
                font-size: 34px;
                 
                font-weight: 600;
                color: #FFFFFF;
                line-height: 47px;
                margin: 0;
                text-align: center;

            }
        }
    }
    .footer{
        background: #151B30;
        width: 100%;
        .footerContent{
            width: 1000px;
            margin: 0 auto;
            .footerHeader{
                position: relative;
                display: flex;
                img{
                    margin-top: 110px;
                }
                .logo{
                    width: 210px;
                    height: 42px;
                    margin-top: 100px;
                    margin-right: 30px;
                }
                ul{
                    position: absolute;
                    right: 0;
                    margin-top: 104px;
                    list-style: none;
                    li{
                        color: #9797B2;
                        cursor: pointer;
                        display: inline-block;
                        margin-left: 40px;
                        font-size: 13px;
                        font-weight: 500;
                    }
                    li:hover{
                        color: #FFFFFF;
                    }
                }
            }
            .footer1{
                width: 79px;
                height: 18px;
                margin-right: 10px;
            }
            .footer2{
                width: 106px;
                height: 16px;
                margin-right: 10px;
            }
            .footer3{
                width: 29px;
                height: 29px;
                margin-right: 10px;
                vertical-align: -5px;
            }
            .footer4{
                width: 71px;
                height: 16px;
                margin-right: 10px;
            }
        }
        .contactUs{
            margin-top: 42px;
            font-size: 13px;
             
            font-weight: 400;
            color: rgb(200,200,200);
            line-height: 28px;
            span{
                text-decoration: underline;
            }
        }
        .standBy{
            width: 330px;
            text-align: center;
            margin: 0 auto;
            font-size: 14px;
            font-weight: 400;
            color: rgb(200,200,200);
            line-height: 19px;
            margin-top: 64px;
            padding-bottom: 60px;
        }
    }
    @keyframes moveSlideshow {
        100% { 
            transform: translateX(-66.6666%);  
        }
    }
}
    .pcheaderBackground{
        width: 100%;
        .headerContent{
            width: 1000px;
            margin: 0 auto;
            padding-bottom: 20px;
        }
        background: #151B30;
        img{
            width: 210px;
            height: 42px;
            margin-top: 18.5px;
        }
        ul{
            float: right;
            margin-top: 28.5px;
            list-style: none;
            li{
                color: #9797B2;
                cursor: pointer;
                display: inline-block;
                margin-left: 40px;
                font-size: 16px;
                font-weight: 500;
            }
            li:hover{
                color: #FFFFFF;
            }
        }
    }
</style>
<style lang="less">
.ivu-input{
    height: 41px !important;
    border-radius: 6px !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #000 !important;
    padding-left: 16px !important;

}
textarea.ivu-input{
    height: 110px !important;
    background: #FFFFFF !important;
    padding-top: 15px !important;

}
.ivu-form .ivu-form-item-label{
    margin-bottom: 16px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    color: #83818B !important;
    line-height: 21px !important;
}
.ivu-btn{
    width: 196px !important;
    height: 66px !important;
    background: #4D31F9 !important;
    border-radius: 33px !important;
    border: 1px solid #4D31F9 !important;
    font-size: 23px !important;
    font-weight: 500 !important;
    color: #FFFFFF !important;
}
.ivu-btn-primary:hover{
    
}
.ivu-form-item-required .ivu-form-item-label:before{
    display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/page/index/index.vue